import clsx from "clsx";
import Image from "next/image";
import { Dispatch, SetStateAction, useRef } from "react";
import bobbineIcon from "@public/bobbine.svg";
import styles from "./PaletteIcon.module.scss";
import useColor from "./Palette.hook";

type Props = {
	disabled: boolean;
	setShowPalette: Dispatch<SetStateAction<boolean>>;
	onShowChange: () => void;
};

/**
 * パレットアイコン コンポーネント
 * @returns {JSX.Element} パレットアイコン コンポーネント
 */
export default function PaletteIcon(props: Props) {
	const { disabled } = props;
	const inputRef = useRef<HTMLInputElement>(null);
	const { initialColor, handleColorChange } = useColor();

	const handleClick = () => {
		if (!disabled && inputRef.current) {
			inputRef.current.click(); // カラーピッカーを開く
		}
	};

	return (
		<div className={styles.colorButton}>
			<Image
				src={bobbineIcon}
				alt="パレットの表示非表示を切り替える"
				className={clsx(styles.icon, disabled && styles.disabled)}
				onClick={() => {
					if (!disabled) {
						handleClick();
					}
				}}
			/>
			<input
				type="color"
				name="example1"
				value={initialColor()}
				ref={inputRef}
				className={styles.colorPicker}
				onChange={handleColorChange}
				disabled={disabled}
			/>
		</div>
	);
}
